import { colorConstants } from "../../constants";

export function colors(state = {}, action) {
  switch (action.type) {
    // get all
    case colorConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case colorConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case colorConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case colorConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case colorConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case colorConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case colorConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case colorConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case colorConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case colorConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case colorConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case colorConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case colorConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
